import angular from 'angular';
import moment from 'moment';

(function() {
  'use strict';
  angular.module('app.core').factory('Seller', SellerData);

  SellerData.$inject = ['LegalEntity', '$translate', 'KISS_SELLER'];

  /* @ngInject */
  function SellerData(LegalEntity, $translate, KISS_SELLER) {
    Seller.prototype = {
      build: build,
      buildEmpty: buildEmpty,
      getSellerNameWithId: getSellerNameWithId,
      getCountryLabel: getCountryLabel,
      getLangLabel: getLangLabel,
      getStatusLabel: getStatusLabel,
      isCreated: isCreated,
      isNotified: isNotified,
      isActive: isActive,
      isInactive: isInactive,
      getName: getName
    };

    function Seller(sellerData) {
      if (!sellerData) {
        this.buildEmpty();
      } else {
        this.build(sellerData);
      }
    }

    return Seller;

    /////////////////////

    function buildEmpty() {
      this.id = null;
      this.legalEntity = new LegalEntity();
      this.invoiceSenderEmail = null;
      this.notificationEmail = null;
      this.cguAckDate = null;
      this.legalForm = null;
      this.registrationPlace = null;
      this.capital = null;
      this.capitalCurrency = null;
      this.insurance = null;
      this.status = null;
      this.lastUsageRemindDate = null;
      this.remindcount = null;
    }

    function build(sellerData) {
      this.id = sellerData.id || null;
      this.legalEntity = new LegalEntity(sellerData.legalEntity);
      this.invoiceSenderEmail = sellerData.invoiceSenderEmail || null;
      this.notificationEmail = sellerData.notificationEmail || null;
      if (sellerData.cguAckDate) {
        this.cguAckDate = moment(sellerData.cguAckDate).toDate() || null;
      }
      this.legalForm = sellerData.legalForm || null;
      this.registrationPlace = sellerData.registrationPlace || null;
      this.capital = sellerData.capital || null;
      this.capitalCurrency = sellerData.capitalCurrency || null;
      this.insurance = sellerData.insurance || null;
      this.status = sellerData.status || null;
      this.lastRemindDate = sellerData.lastRemindDate;
      this.remindcount = sellerData.remindcount || 0;
    }

    function getSellerNameWithId() {
      if (this.legalEntity) {
        return this.legalEntity.getNameForList();
      }
      return '';
    }

    function getLangLabel() {
      return $translate.instant('lang.' + angular.lowercase(this.legalEntity.language));
    }

    function getStatusLabel() {
      if (this.status) {
        return $translate.instant('kiss_seller.status.' + angular.lowercase(this.status));
      }
      return '';
    }

    function getCountryLabel() {
      //return $translate.instant('country.' + angular.lowercase(this.legalEntity.countryCode));
      if (this.legalEntity) {
        return this.legalEntity.getCountryLabel();
      }
      return '';
    }

    function isCreated() {
      return this.status && this.status === KISS_SELLER.seller.status[0].value;
    }

    function isNotified() {
      return this.status && this.status === KISS_SELLER.seller.status[1].value;
    }

    function isActive() {
      return this.status && this.status === KISS_SELLER.seller.status[2].value;
    }

    function isInactive() {
      return this.status && this.status === KISS_SELLER.seller.status[3].value;
    }

    /**
     * Fournit le nom et l'id du fournisseur.
     * La fonction s'appelle "getName" pour son utilisation dans Typeahead afin d'avoir le même même nom que dans principal-detail.data.
     */
    function getName() {
      return this.getSellerNameWithId();
    }
  }
})();
